const INVALIDATION_MAP = {
  ORDER_SERVICE_DELETE: [
    ["orders"],
    ["contractsByIds"],
    ["contractOrders"],
    ["contractItemsForMovement"],
    ["contractDetails"],
    ["equipments"],
    ["almox_products"],
    ["contractItems"],
  ],
  SHIPMENT_DELETE: [
    ["orders"],
    ["shipments"],
    ["movementShipments"],
    ["movements"],
    ["movementItems"],
    ["expectedShipmentItems"],
    ["shipmentDetails"],
    ["shipmentReceivedItems"],
  ]
};

export const invalidateByEvent = (queryClient, event) => {
  const keys = INVALIDATION_MAP[event];
  if (keys) {
    keys.forEach((key) => queryClient.invalidateQueries({ queryKey: key }));
  }
};
